/**
 * №22.6 — the ONE react-query key for the Needs-You card feed.
 *
 * Three readers share it (the home, the nav badge, and every `invalidateQueries`
 * after an answer), and they must share the CACHE ENTRY, not just the string:
 * react-query dedupes by key, so a second key for the same tool call is a second
 * network request. Consumers differ by `select`, not by key.
 *
 * It is a named constant rather than a literal in three files because "answering
 * anywhere clears it everywhere" (D-CC4) is only true while all three agree, and a
 * typo in one of them degrades silently to a stale badge.
 */
export const NEEDS_YOU_KEY = ["needs-you"] as const;
